import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';
import { fadeIn } from 'utils/style/animations';

export const ReloadWrapper = styled.div`
  animation: ${fadeIn} 1s;
  margin: 1rem 0;
`;

// Only used on TH component
export const ReloadExplanationText = styled.div``;

export const InstructionText = styled.p`
  font-size: 0.9rem;
  margin: 1rem 0 0.65rem;
  width: 100%;
  padding: 0;
  font-weight: 700;
  margin: 0.75rem 0 0.625rem;
`;

export const LoadContainer = styled.div`
  margin-top: ${primitive.$spacing6};

  > div {
    width: 100%;
    min-width: 255px;
    border-color: ${Styles.color.grey.four};
    background-color: ${primitive.$white};
  }
`;
